










































































import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    PropType,
    watch,
    Ref,
    ref,
} from '@vue/composition-api';
import multiTag from './multi-tag.vue';
import { MultiSelectOptionType, GroupSearchOption } from '../type';
import { useOutListener } from './out-click-listener';

export default defineComponent({
    props: {
        searchItem: {
            type: Object as PropType<GroupSearchOption>,
            required: true,
        },
        appId: {
            type: String,
            required: true,
        },
    },
    components: {
        multiTag,
    },
    setup(props, context) {
        const options = computed(() => {
            const optionGroup: MultiSelectOptionType[] = [];
            props.searchItem.searchOption.split(';').forEach((item: string) => {
                if (item) {
                    const temp = (item as string).split('|');
                    optionGroup.push({
                        caption: temp[0],
                        title: temp[1],
                    });
                }
            });
            return optionGroup;
        });
        const selectedOptions: Ref<Array<MultiSelectOptionType>> = ref([]);
        const isSelectActive = ref(false); // 控制下拉多选面板
        const isShowActive = ref(false); // 控制展示面板
        const checkedOptions: Ref<Array<string>> = ref([]);
        const root = ref<HTMLElement | null>(null);
        const checkedAll = ref(true);
        function setShowActive() {
            if (isSelectActive.value) {
                isSelectActive.value = false;
            }
            isShowActive.value = !isShowActive.value;
        }

        function emitValue() {
            context.emit('update-checked-options', {
                type: props.searchItem.searchName,
                value: checkedOptions.value,
            });
        }
        function setSelectActive() {
            if (isShowActive.value) {
                isShowActive.value = false;
            }
            isSelectActive.value = !isSelectActive.value;
            if (!isSelectActive.value) {
                emitValue();
            }
        }

        function handleCheckedChange(e?: any) {
            checkedAll.value =
                checkedOptions.value.length === options.value.length;
            selectedOptions.value = options.value.filter(
                (option: MultiSelectOptionType) => {
                    return checkedOptions.value.includes(option.caption);
                },
            );
            if (selectedOptions.value.length < 3) {
                isShowActive.value = false;
            }
        }

        function handleCheckedChangeAll(val: boolean) {
            checkedOptions.value = val
                ? options.value.map((item) => item.caption)
                : [];
            handleCheckedChange();
        }

        function deleteCheckedOption(caption: string) {
            checkedOptions.value = checkedOptions.value.filter(
                (item) => item !== caption,
            );
            handleCheckedChange();
            emitValue();
        }

        useOutListener(root, () => {
            if (isShowActive.value) {
                isShowActive.value = false;
            }
            if (isSelectActive.value) {
                isSelectActive.value = false;
                emitValue();
            }
        });

        watch(
            () => props.appId,
            (val) => {
                if (val) {
                    checkedOptions.value = [options.value[0].caption];
                    handleCheckedChange();
                }
            },
            { immediate: true },
        );

        return {
            selectedOptions,
            isSelectActive,
            isShowActive,
            setShowActive,
            setSelectActive,
            checkedOptions,
            handleCheckedChange,
            root,
            deleteCheckedOption,
            options,
            checkedAll,
            handleCheckedChangeAll,
        };
    },
});
